// @flow
import * as React from 'react';

import './CtaStepIndicator.scss';

type Props = {
  className: string,
  labels: Array<string>,
  step: string,
  activeStep: number,
  lastStep?: number
};

const CtaStepIndicator = (props: Props) => {
  const { className, labels, step, activeStep, lastStep } = props;
  const finalStep = lastStep ? lastStep : labels.length;
  const progress = ((activeStep - 1) / (finalStep - 1)) * 100;
  return (
    <div className={`cta-step-indicator ${className ? className : ''}`}>
      <ul>
        {labels.map((label, i) => {
          const status =
            activeStep && activeStep > i + 1
              ? 'cta-step-indicator--complete'
              : activeStep === i + 1
                ? 'cta-step-indicator--active'
                : '';
          return i + 1 > lastStep ? (
            ''
          ) : (
            <li
              key={label}
              className={status ? ` ${status}` : ''}
              data-trackerindex={step}
            >
              <div className="cta-step-indicator__step">{i + 1}</div>
              <div className="cta-step-indicator__label">{label}</div>
            </li>
          );
        })}
      </ul>
      <div className="cta-step-indicator__bar" />
      <div
        className="cta-step-indicator__barValue"
        style={{ width: progress + '%' }}
      />
    </div>
  );
};

export default CtaStepIndicator;



// WEBPACK FOOTER //
// ./src/components/atoms/CtaStepIndicator/CtaStepIndicator.js